import React, { Fragment } from "react";
import { Container, Row, Col} from "react-bootstrap";
import { Link } from "react-router-dom";


const Online = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/site/online.jpg)'}}>
        <h1 style={{color:'white'}}>Creativity Platform</h1>
      </div> 

      <Container fluid className="p-5">
         <Row className="mt-5">
            <Col className="col-12 col-md-4">
               <h2>Brainteasers and Projects</h2>
               <p> Our short, fun brainteasers, teach students different cognitive creativity techniques like associative thinking or reverse thinking and span different subject areas. Through our Project Based Learning modules, students learn to apply the cognitive techniques in real world scenarios.
               </p>
            </Col>

            <Col className="col-12 col-md-4">
               <h2>Ideal for Classrooms</h2>
               <p> Our convenient teacher portal makes it easy to assign brainteasers to the class, view student submissions and evaluate them using our creativity rubric based on Guilford's metrics (fluency, flexibility, originality and elaboration)
               </p>
            </Col>

            <Col className="col-12 col-md-4">
               <h2>Fun for Students</h2>
               <p> Students love our open-ended brainteasers and projects that allow them the freedom to explore their ideas whichever way they want. In creativity, there is no wrong answer! Students can explore other solutions once they submit their own, send "High Fives" for the ideas they like and even submit their own brainteaser idea!
               </p>
            </Col>
         </Row>

         <Row className="mt-5">
            <p className="lead"> Learn more about the <Link to="/brainteasers"> cognitive brainteasers </Link> and <Link to="/pbl"> project based learning </Link> modules on our platform.</p>
         </Row>
        


      </Container>

      
      

    </Fragment>
       
  );
};
  
export default Online;